var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-2",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.atualizarFiscalizacao()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Atualizar fiscalização\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }